import { Component, OnInit, Input } from '@angular/core'
import { LogoDetails } from 'models'

@Component({
    selector: 'app-logo-uploader',
    template: require('./logo-uploader.component.html'),
    styles: [require('./logo-uploader.component.scss')],
    host: { class: "flex flex-col flex-1 overflow-y-auto" }
})

export class LogoUploaderComponent implements OnInit {
    @Input('logoDetails') logoDetails: LogoDetails;

    logoUrl: string;
    isShowLogo = false;

    ngOnInit() {
        this.refreshLogo();
    }

    private refreshLogo() {
        this.logoDetails.getUrl().subscribe(r => {
            this.logoUrl = r;
        });
    }

    uploadLogoHandler($event) {
        this.logoDetails.uploadLogo($event.target.files).subscribe(() => {
            this.refreshLogo();
        });
    }

    toggleLogo() {
        this.isShowLogo = !this.isShowLogo;
    }
}